import { call, put, takeLatest } from "redux-saga/effects";

import { getTokenInfoSuccess, getTokenInfoFailure } from "./TokenInfo.actions";
import { TokenInfoService } from "./TokenInfo.store";

function* getTokenInfoSaga(args) {
  try {
    const tokenInfoService = new TokenInfoService();
    const data = yield call(tokenInfoService.fetchTokenInfo, args);
    yield put(getTokenInfoSuccess(data));
  } catch (error) {
    yield put(getTokenInfoFailure(error));
  }
}

export function* tokenInfoSagas() {
  const GET_TOKENINFO = "GET_TOKENINFO";
  yield takeLatest(GET_TOKENINFO, getTokenInfoSaga);
}
